import { useMemo } from "react";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { usePageMeta } from "@/hooks/usePageMeta";
import { useFavorites } from "@/hooks/useFavorites";
import { movies, themeCollections } from "@/mocks/movies";
import HeroCarousel from "./components/HeroCarousel";
import CategoryQuickEntry from "./components/CategoryQuickEntry";
import MovieRow from "./components/MovieRow";
import ThemeSection from "./components/ThemeSection";
import SiteIntro from "./components/SiteIntro";

export default function Home() {
  usePageMeta({
    title: "伦理影院 - 精选伦理影视剧免费在线观看平台",
    description:
      "伦理影院为您提供丰富的伦理类影视剧资源，涵盖最新伦理电影和电视剧，满足您的观影需求，尽享多样影视体验。",
    keywords: "伦理影院,伦理影视,伦理电影,伦理电视剧,影视平台",
  });

  const { favorites, toggleFavorite } = useFavorites();

  const latestMovies = useMemo(
    () => [...movies].filter((m) => m.type === "movie").sort((a, b) => b.year - a.year).slice(0, 10),
    [],
  );
  const hotSeries = useMemo(
    () => [...movies].filter((m) => m.type === "tv").sort((a, b) => b.popularity - a.popularity).slice(0, 10),
    [],
  );

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <HeroCarousel movies={movies} />
        <CategoryQuickEntry />
        <MovieRow
          title="最新伦理电影"
          subtitle="新近上映的伦理题材电影，故事完整、节奏紧凑"
          moreLink="/category?type=movie"
          movies={latestMovies}
          favorites={favorites}
          onToggleFavorite={toggleFavorite}
        />
        <MovieRow
          title="热门伦理电视剧"
          subtitle="高口碑长线剧集，跟随人物走进更复杂的伦理命题"
          moreLink="/category?type=tv"
          movies={hotSeries}
          favorites={favorites}
          onToggleFavorite={toggleFavorite}
        />
        <ThemeSection themes={themeCollections} />
        <SiteIntro />
      </main>
      <SiteFooter />
    </div>
  );
}